
import Component from "vue-class-component";
import Vue from "vue";
import {BModal} from "bootstrap-vue";
import bus from "@/EventBus";

@Component
export default class ConcurrencyWarningModal extends Vue {

    errorMessage = "";
    
    $refs!: { bmodal: BModal }

    mounted() {
        bus.subscribe('concurrency-error-occurred', (args: string[]) => this.show((args || [])[0]), this);
    }
    
    private reloadPage() {
        window.location.reload();
    }

    private show(errorMessage: string) {
        this.errorMessage = errorMessage;
        this.$refs.bmodal.show();
    }
}
